import ErrorDisplay from "../errorDisplay";

import './style.scss';

let idx = 0;

const Input = (props) => {
  const {
    type,
    name,
    id,
    label,
    placeholder,
    value,
    changeAction,
    onKeyDown,
    errors,
    autoComplete,
    autoFocus,
    disabled,
    focusOnError
  } = props;

  const idValue = id || label || name;
  const hasError = Boolean(errors?.length);
  const errorId = 'error-' + idx++;

  return (
    <div className='form-input'>
      <label htmlFor={idValue}>{label || name || id}</label>
      <input
        className={hasError ? 'error' : ''}
        id={idValue}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        aria-describedby={hasError ? errorId : null}
        autoComplete={autoComplete || 'off'}
        autoFocus={autoFocus}
        onChange={(e) => {
          e.preventDefault();
            changeAction(e.target.value);
          }
        }
        onKeyDown={onKeyDown || null}
      />
      { hasError && <ErrorDisplay shouldFocus={focusOnError} errors={errors} id={errorId}/> }
    </div>
  )
};

export default Input;
